import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import type { VueQueryPluginOptions } from '@tanstack/vue-query'

// custom query client to be able to access it outside of vue components
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: Error) => {
        if (error && typeof error === 'object' && 'status' in error) {
          const status = (error as { status: number }).status

          // client errors are not worth retrying
          if (status >= 400 && status < 500) return false
        }

        return failureCount < 3
      },
    },
  },
})

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClient,
  enableDevtoolsV6Plugin: true,
}

export { VueQueryPlugin, vueQueryPluginOptions }
